const API_KEY = 'gU1G0TXR_NS5SApO4Y5sDg';
const API_SECRET = 'etCl5_Xk8ChHMIN6iYiM8K7l09wWKtw';
 
const options = {
  headers: new Headers({
    Authorization: `Basic ${btoa(`${API_KEY}:${API_SECRET}`)}`
  })
};

const postOptions = {
  ...options,
  method: 'POST'
};

export function fetchProductReviews(productId) {
  return fetch(`/v4/organisations/CYS/reviews?sku=${productId}&locale=en-GB`, options);
}

export function fetchConversations(productId) {
  return fetch(`/v4/organisations/CYS/conversations?sku=${productId}`, options);
}

export function fetchOrganizationStatistics() {
  return fetch('/v4/organisations', options);
}

export function fetchOrganizationReviews() {
  return fetch('/v4/organisations/CYS/customer_experience_reviews', options);
}

export function upVoteReview(reviewId) {
  return fetch(`/v4/reviews/${reviewId}/increment_helpful?trkref=CYS`, postOptions);
}

export function downVoteReview(reviewId) {
  return fetch(`/v4/reviews/${reviewId}/increment_unhelpful`, postOptions);
}

export function upVoteQuestion(questionId) {
  return fetch(`/v4/conversations/${questionId}/increment_helpful`, postOptions);
}

export function downVoteQuestion(questionId) {
  return fetch(`/v4/conversations/${questionId}/increment_unhelpful`, postOptions);
}

export function upVoteAnswer(answerId) {
  return fetch(`/v4/conversation_answers/${answerId}/increment_helpful`, postOptions);
}

export function downVoteAnswer(answerId) {
  return fetch(`/v4/conversation_answers/${answerId}/increment_unhelpful`, postOptions);
}
